const _ = require("lodash");
const Constants = require("./Constants");
const activeGrades = require("./data/dbGradeChapterBlock.json").activeGrades;
const GradeChapter = require("./GradeChapter");
const LabUtil = require("./LabUtil");

// This file contains various operations and data on page objects that used to
// be in frontend or backend code only, but they are needed by both. In most
// cases, the original locations require and re-export this file.
// TODO: file has a bunch of somewhat unrelated things. better way to organize?

//
// From OpsUser
//
const getLastPlayedDataFromUser = function(user) {
	const gradeID = _.get(user, "model.gradeID");
	const userLastPlayedData = _.get(user, "model.lastPlayedData");
	if (!userLastPlayedData || _.isEmpty(userLastPlayedData)) {
		return {
			gradeNumber: gradeID,
			chapterIndex: 0,
			typeID: LabUtil.getActiveTypeIDs()[0],
		};
	} else {
		const chapters = _.get(userLastPlayedData, "chapters");
		const gradeNumber = _.get(userLastPlayedData, "gradeNumber");
		const chapterID = _.get(chapters, 0);

		let lastPlayedData;
		if (!_.isInteger(chapterID)) {
			lastPlayedData = {
				gradeNumber: gradeNumber || gradeID,
				chapterIndex: 0,
			};
		} else {
			lastPlayedData = _.pick(GradeChapter.chapterIDToContext(chapterID), [
				"gradeNumber",
				"chapterIndex",
			]);
		}
		if (!_.get(userLastPlayedData, "typeID")) {
			lastPlayedData.typeID = LabUtil.getActiveTypeIDs()[0];
		}

		lastPlayedData = _.extend(
			lastPlayedData,
			_.pick(userLastPlayedData, ["room", "testInProgress", "typeID"])
		);
		return lastPlayedData;
	}
};

const getDefaultMostRecentPageData = function(user) {
	return {
		gradeNumber: _.get(user, "model.gradeID", activeGrades[0]),
		chapterIndex: 0,
		typeID: LabUtil.getActiveTypeIDs()[0],
	};
};

// Forces this return to be last played data if user just logged in.
const getMostRecentPageDataForUser = function(user) {
	let mrpd = _.get(user, "model.mostRecentPageData", {});
	const justLoggedIn = _.get(user, "justLoggedIn");
	const gNum = parseInt(_.get(mrpd, "gradeNumber"));
	const sequenceData = _.get(user, "model.sequenceData", {});
	if (
		justLoggedIn ||
		(!GradeChapter.isActiveGrade(gNum) && !_.get(mrpd, "typeID"))
	) {
		mrpd = getLastPlayedDataFromUser(user);
	} else if (sequenceData && (!mrpd || _.isEmpty(mrpd))) {
		// The user should go to the last grade/chapter they looked at.
		// The sequence data stores this independent of gradeless/chapterless
		// pages like Puzzle Lab, etc
		mrpd = sequenceData;
	}
	return _.extend(getDefaultMostRecentPageData(user), mrpd);
};

const getTeachToOneTrainerPageDefault = function() {
	return {
		gradeNumber: 3,
		chapterIndex: 0,
		blockIndex: 0,
	};
};

//
// From OpsPage
//

const getNameParts = function(page) {
	if (!page || !page.name) return [];
	return page.name.split(".");
};

const isTrainerPage = function(page) {
	// TODO: May want to split this up in the future if library becomes something
	// separate people can access?
	const parts = getNameParts(page);
	return (
		parts[0] === "trainer" ||
		parts[0] === "library" ||
		parts[0] === "theater" ||
		parts[0] === "lab"
	);
};

const isTrainerChapterPage = function(page) {
	const parts = getNameParts(page);
	return parts[0] === "trainer" && parts[1] === "chapter";
};

const isTrainerProblemPage = function(page) {
	const parts = getNameParts(page);
	return parts[0] === "trainer" && parts[1] === "problem";
};

const isDevProblemPage = function(page) {
	const parts = getNameParts(page);
	return (
		parts[0] === "trainer" &&
		(parts[1] === "devProblem" || parts[1] === "devEngineTester")
	);
};

// Trainer pages that count as core curriculum
// includes trainer/library/theater
// doesn't include lab/gym
const isCoreTrainerPage = function(page) {
	// TODO: May want to split this up in the future if library becomes something
	// separate people can access?
	const parts = getNameParts(page);
	return (
		parts[0] === "trainer" || parts[0] === "library" || parts[0] === "theater"
	);
};

const isOfficePage = function(page) {
	//TODO: Generalize.
	const parts = getNameParts(page);
	return (
		parts[0] === "office" ||
		parts[0] === "parent" ||
		parts[0] === "school" ||
		page.name === "404"
	);
};

const isHomeMain = function(page) {
	const parts = getNameParts(page);
	return (parts[0] === "home" || parts[0] === "office") && parts[1] === "main";
};

const isHomeOnboarding = function(page) {
	const parts = getNameParts(page);
	return parts[0] === "home" && parts[1] === "onboarding";
};

//
// For OpsDemo and URLMake forDemo
//

const isValidDemoPage = function(page) {
	const demoPages = [
		"trainer.chapter",
		"trainer.problem",
		"trainer.history",
		"theater.chapter",
		"theater.set",
		"library.grade",
		"library.chapter",
		"home.main",
		"profile.main",
	];
	return demoPages.includes(page.name);
};

//
// From BookstoreUtil
//

const bookData = require("./data/dbBooks.json");
const availableBookHashes = _.keys(_.pickBy(bookData, b => b.isAvailable));
const availableGradeSets = ["1", "2", "3", "4", "5", "3S", "4S"];

const getAvailableBooks = function(options = {}) {
	let books = _.clone(availableBookHashes);
	if (_.includes(options.excludeTypes, "puzzle")) {
		books = _.filter(books, b => !isPuzzleBook(b));
	}
	if (_.includes(options.excludeTypes, "science")) {
		books = _.filter(books, b => !isScienceBook(b));
	}
	if (options.excludeBooks && _.isArray(options.excludeBooks)) {
		books = _.without(books, ...options.excludeBooks);
	}
	const sortFunc = hash => {
		if (isPuzzleBook(hash)) {
			return hash.substring(7) + "puzzles";
		} else {
			return isScienceBook(hash) ? hash[0] + "s" + hash[1] : hash;
		}
	};
	return _.sortBy(books, [sortFunc]);
};

const getAvailableBookRegex = function() {
	return new RegExp("^(" + availableBookHashes.join("|") + ")$", "i");
};

const getAvailableBookLevels = function() {
	return _.uniq(_.map(availableBookHashes, h => parseInt(h)));
};

const isPuzzleBook = function(bookHash) {
	return /^puzzles\d$/.test(bookHash);
};

const isScienceBook = function(bookHash) {
	return /^\d[A-D]S$/.test(bookHash);
};

const isMathBook = function(bookHash) {
	return /^\d[A-D]$/.test(bookHash);
};

//
// From ApparelUtil
//
const shopData = require("./data/dbShop.json");
const getAllApparelSkus = function() {
	return _.keys(_.pickBy(shopData, i => i.type === "apparel"));
};

const getApparelInfoFromSku = function(sku) {
	const apparelItem = shopData[sku];
	const apparelRegex = new RegExp(
		`(.*)-((${Constants.APPAREL_CLASSES.join(
			"|"
		)})-(${Constants.APPAREL_SIZES.join("|")}))$`
	);
	const match = sku.match(apparelRegex);
	return _.extend(apparelItem, {
		apparelHash: match[1],
		size: match[2],
	});
};

// A regex to test whether something has a valid apparel prefix, ignoring class and size.
// For instance, whether the "shirt-beast" part of "shirt-beast-mens-small" is a valid prefix.
const getApparelRegex = function() {
	// Turn a string like "shirt-beast-mens-small" to "shirt-beast"
	const availableApparelPrefixes = _.uniq(
		_.map(getAllApparelSkus(), sku => getApparelInfoFromSku(sku).apparelHash)
	);
	return new RegExp("^(" + availableApparelPrefixes.join("|") + ")$", "i");
};

//
// From PageComponent / server bundles util
//

// Format is page name: [bundleName, moduleName]. Here moduleName is a key in
// the exports of the bundle's main file. If bundleName is null, then the
// component should be in the core bundle, and moduleName should be a key in
// PageComponent.jsx's corePageComponents variable.
const pageModuleTable = {
	"404": [null, "Page404"],
	"home.main": [null, "PageHome"],
	"home.onboarding": [null, "PageOnboarding"],
	// This is an empty page with MainContainer background that we can redirect
	// to while we figure out what default page to load
	"home.postSignin": [null, "PagePostSignin"],
	// Student things:
	"trainer.chapter": ["trainer", "PageChapter"],
	"trainer.problem": ["trainer", "PageProblem"],
	"trainer.devProblem": ["trainer", "PageDevProblem"],
	"trainer.devEngineTester": ["trainer", "PageDevEngineTester"],
	"trainer.history": ["trainer", "PageHistory"],
	"profile.main": ["profile", "PageProfile"],
	"beastbuilder.main": ["beastbuilder", "PageBeastBuilder"],
	"library.grade": ["library", "PageLibraryGrade"],
	"library.chapter": ["library", "PageLibraryChapter"],
	"theater.chapter": ["theater", "PageTheaterChapter"],
	"theater.set": ["theater", "PageTheaterSet"],
	"lab.lobby": ["lab", "PageLabLobby"],
	"lab.type": ["lab", "PageLabLobby"],
	"lab.problem": ["lab", "PageLabProblem"],
	// Office Sell Pages:
	"office.main": ["office", "PageLoggedInHome"],
	"office.resources": ["office", "PageResources"],
	"office.checkout": ["office", "PageCheckout"],
	"office.chalkboard": ["office", "PageChalkboard"],
	"office.mailinglist": ["office", "PageMailingList"],
	"office.confirmEmail": ["office", "PageConfirmEmail"],
	"office.autoRenew": ["office", "PageEnableAutoRenew"],
	"office.accountSetup": ["office", "PageAccountSetup"],
	"office.termsAndPrivacy": ["office", "PagePrivacyAndTerms"],
	"office.redeemSubscription": ["office", "PageRedeemSubscription"],
	// Office CMS Info Pages:
	"office.cmsInfoPages": ["office", "PageInfo"],
	// Parent Report/Account Pages:
	"parent.main": ["parent", "PageParent"],
	"parent.student": ["parent", "PageParentStudent"],
	"parent.support": ["parent", "PageParentSupport"],
	"parent.account": ["parent", "PageAccount"],
	"parent.subscribe": ["parent", "PageSubscribe"],
	"parent.giftBucksConfirmation": ["parent", "PageGiftBucksConfirmation"],
	"parent.studentPrimaryRegistration": ["parent", "PagePrimaryRegistration"],
	// Office School Pages:
	"school.main": ["school", "PageSchool"],
	"school.testList": ["school", "PageSchoolTestList"],
	"school.classReports": ["school", "PageClassReports"],
	"school.profile": ["school", "PageStaffProfile"],
	"school.classCards": ["school", "PageClassCards"],
	// Parent+school page for printables. Loads a new tab so it doesn't matter
	// too much what bundle it goes in.
	"school.studentProblem": ["school", "PagePrintStudentProblem"],
};

const computeBundlesForPage = function(page) {
	const bundleName = _.get(pageModuleTable, [page && page.name, 0]);
	return bundleName ? [bundleName] : [];
};

//
// server/main
//

const canRenderPageOnServer = function(page) {
	const parts = getNameParts(page);
	// TODO: This should just always return false to remove server-side rendering
	return (
		(parts[0] === "office" &&
			parts[1] !== "checkout" &&
			parts[1] !== "accountSetup") ||
		page.name === "404"
	);
};

//

const fixPath = function(path, delimiter = "/") {
	if (!path || !path.length) return "";
	if (_.isArray(path)) {
		return path.join("/");
	} else if (_.isString(path)) {
		return path.replace(/^\//, "");
	}
	return path + "";
};

module.exports = {
	getNameParts,
	getLastPlayedDataFromUser,
	getDefaultMostRecentPageData,
	getMostRecentPageDataForUser,
	getTeachToOneTrainerPageDefault,
	isOfficePage,
	isHomeMain,
	isHomeOnboarding,
	isValidDemoPage,
	isTrainerPage,
	isTrainerChapterPage,
	isTrainerProblemPage,
	isDevProblemPage,
	isCoreTrainerPage,
	availableGradeSets,
	getAvailableBooks,
	getAvailableBookRegex,
	getAvailableBookLevels,
	isPuzzleBook,
	isScienceBook,
	isMathBook,
	getApparelInfoFromSku,
	getApparelRegex,
	getAllApparelSkus,
	pageModuleTable,
	computeBundlesForPage,
	canRenderPageOnServer,
	fixPath,
};
